import api from "./api";
var queryString = (params) => {
  return Object.keys(params)
    .map((key) => key + "=" + params[key])
    .join("&");
};
export const getRequests = (params) => {
    return api.get("/v1/crm/requests?" + queryString(params));
  };